mutation EnsureAccountOverlayLink($targetKind: String!, $targetId: ID!, $regenerate: Boolean) {
  link: StreamToolsEnsureAccountOverlayLink(targetKind: $targetKind, targetId: $targetId, regenerate: $regenerate) {
    linkId
    k
    targetKind
    targetId
    connectionCap
    createdAt
  }
}
